module.exports = __webpack_public_path__ + "img/gpay.3c402336.png";